"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userPermissionsModel = exports.userModel = exports.UserPermissionContext = exports.CurrentUserContext = void 0;
exports.withUserContext = withUserContext;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _preactCompat = require("preact-compat");

var _zod = require("zod");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

console.log();

var userModel = _zod.z.object({
  id: _zod.z.number().or(_zod.z.null()),
  email: _zod.z.string(),
  name: _zod.z.string(),
  avatar: _zod.z.string(),
  isModerator: _zod.z.boolean(),
  rank: _zod.z.string().or(_zod.z.null()),
  rankIcon: _zod.z.string().or(_zod.z.null()),
  rankName: _zod.z.string(),
  role: _zod.z.string(),
  mainRole: _zod.z.string(),
  pmUnreadCount: _zod.z.number(),
  pmTotalCount: _zod.z.number(),
  topicsCount: _zod.z.number(),
  repliesCount: _zod.z.number(),
  solvedCount: _zod.z.number(),
  loginSource: _zod.z.string().nullable(),
  registerSource: _zod.z.string().nullable(),
  joindate: _zod.z.number(),
  likes: _zod.z.number(),
  likes_given: _zod.z.number(),
  profileFields: _zod.z.array(_zod.z.object({
    id: _zod.z.string(),
    title: _zod.z.string(),
    value: _zod.z.string().nullable().or(_zod.z.object({}).passthrough())
  })).default([]),
  badges: _zod.z.array(_zod.z.object({
    id: _zod.z.string(),
    title: _zod.z.string()
  })).default([])
}).default({
  id: null,
  email: '',
  name: '',
  avatar: '',
  isModerator: false,
  rankIcon: '',
  rankName: '',
  rank: null,
  role: 'roles.guest',
  mainRole: 'roles.guest',
  pmUnreadCount: 0,
  pmTotalCount: 0,
  topicsCount: 0,
  repliesCount: 0,
  solvedCount: 0,
  loginSource: null,
  registerSource: null,
  joindate: 0,
  likes: 0,
  likes_given: 0,
  profileFields: [],
  badges: []
});

exports.userModel = userModel;

var userPermissionsModel = _zod.z.object({
  permissions: _zod.z.array(_zod.z.string()).optional().default([]),
  readableCategories: _zod.z.array(_zod.z.number()).optional().default([])
});

exports.userPermissionsModel = userPermissionsModel;
var CurrentUserContext = (0, _preactCompat.createContext)(userModel.parse(undefined));
exports.CurrentUserContext = CurrentUserContext;
var UserPermissionContext = (0, _preactCompat.createContext)({
  permissions: [],
  readableCategories: []
});
exports.UserPermissionContext = UserPermissionContext;

function withUserContext(WrappedComponent) {
  return /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(WithUserContextWrapper, _Component);

    var _super = _createSuper(WithUserContextWrapper);

    function WithUserContextWrapper() {
      (0, _classCallCheck2.default)(this, WithUserContextWrapper);
      return _super.apply(this, arguments);
    }

    (0, _createClass2.default)(WithUserContextWrapper, [{
      key: "render",
      value: function render() {
        var props = this.props;
        return (0, _preact.h)(CurrentUserContext.Consumer, null, function (user) {
          return (0, _preact.h)(UserPermissionContext.Consumer, null, function (permissions) {
            return (0, _preact.h)(WrappedComponent, (0, _extends2.default)({}, props, {
              user: user,
              permissions: permissions
            }));
          });
        });
      }
    }]);
    return WithUserContextWrapper;
  }(_preact.Component);
}